import Reveal from "../components/Reveal";
import { Link } from "react-router-dom";

export default function Privacy() {
  return (
    <section className="container-prose pt-16 sm:pt-24 pb-24">
      <Reveal>
        <span className="pill pill-lav">Privacy</span>
        <h1 className="mt-5 font-display text-5xl sm:text-6xl leading-[1.02] text-balance">
          We handle your information <em className="not-italic grad-text">with care.</em>
        </h1>
        <p className="mt-6 text-lg text-ink-500 leading-relaxed">
          Sanctology Welfare Foundation is the data controller for any
          personal information collected through this website. We collect
          only what's needed to respond to waitlist, volunteer, and contact
          submissions, and we keep records for as long as we need them to
          provide care or comply with applicable law.
        </p>
      </Reveal>

      <Reveal delay={80}>
        <div className="surface mt-10 space-y-5">
          <h2 className="font-display text-2xl">What we collect</h2>
          <ul className="space-y-3 text-ink-700 leading-relaxed">
            <li>
              <strong className="text-ink-900">Form submissions:</strong>{" "}
              name, contact details, the situation you describe, and any
              other fields you fill in on a waitlist, volunteer, or contact
              form.
            </li>
            <li>
              <strong className="text-ink-900">Consent records:</strong> a
              timestamped log of every cookie-consent decision (you, your
              choices, the policy version, your IP country, and a one-way
              hash of your IP — never the raw IP).
            </li>
            <li>
              <strong className="text-ink-900">Strictly-necessary cookies:</strong>{" "}
              site routing and remembering your consent choice. No analytics
              unless you opt in.
            </li>
          </ul>
        </div>
      </Reveal>

      <Reveal delay={120}>
        <div className="surface mt-6 space-y-5">
          <h2 className="font-display text-2xl">Where it goes</h2>
          <p className="text-ink-700 leading-relaxed">
            Form submissions are emailed to our team at{" "}
            <code className="font-mono text-sm">hope@sanctology.com</code>{" "}
            and stored in our HubSpot CRM (under contact + lead records) so
            we can follow up with care. Consent records are stored in
            Cloudflare KV for 24 months as an audit trail.
          </p>
          <p className="text-ink-700 leading-relaxed">
            We don't sell, share, or trade your information. We don't run
            advertising. We don't use analytics that build profiles.
          </p>
        </div>
      </Reveal>

      <Reveal delay={160}>
        <div className="surface mt-6 space-y-5">
          <h2 className="font-display text-2xl">Your rights</h2>
          <p className="text-ink-700 leading-relaxed">
            You can ask us at any time to: confirm what we hold about you,
            correct it, delete it, give you a portable copy, restrict how we
            use it, or withdraw a consent you previously gave. Email{" "}
            <a
              href="mailto:hope@sanctology.com"
              className="text-royal hover:text-royal-hi underline"
            >
              hope@sanctology.com
            </a>{" "}
            and we'll respond within applicable timeframes (1 month under
            UK/EU GDPR; 45 days under CCPA).
          </p>
        </div>
      </Reveal>

      <Reveal delay={200}>
        <div className="mt-10 text-sm text-ink-500 leading-relaxed">
          <p>
            For information about cookies specifically, see our{" "}
            <Link
              to="/cookies"
              className="text-royal hover:text-royal-hi underline"
            >
              cookie policy
            </Link>
            . This privacy notice is a placeholder draft; final wording is
            being reviewed by counsel before go-live.
          </p>
        </div>
      </Reveal>
    </section>
  );
}
